export function lengthToReadable(configLength: number | number[]): string {
  if (Array.isArray(configLength)) {
    return `${configLength[0]}-${configLength[1]}`;
  }
  return String(configLength);
}
